var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rb-combo-mini-slider" },
    [
      _c(
        "rb-smart-box",
        _vm._b(
          {
            scopedSlots: _vm._u(
              [
                {
                  key: "title",
                  fn: function () {
                    return [_vm._t("title")]
                  },
                  proxy: true,
                },
                {
                  key: "title_block",
                  fn: function () {
                    return [_vm._t("title_block")]
                  },
                  proxy: true,
                },
                {
                  key: "excerpt",
                  fn: function () {
                    return [_vm._t("excerpt")]
                  },
                  proxy: true,
                },
                {
                  key: "excerpt_block",
                  fn: function () {
                    return [_vm._t("excerpt_block")]
                  },
                  proxy: true,
                },
                {
                  key: "cta_1",
                  fn: function () {
                    return [_vm._t("cta_1")]
                  },
                  proxy: true,
                },
                {
                  key: "cta_block",
                  fn: function () {
                    return [_vm._t("cta_block")]
                  },
                  proxy: true,
                },
                {
                  key: "other_elements",
                  fn: function () {
                    return [
                      _c(
                        "rb-plain-slider",
                        { attrs: { "slider-config": _vm.sliderConfig } },
                        [_vm._t("other_elements")],
                        2
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          },
          "rb-smart-box",
          Object.assign({}, _vm.$props, _vm.$attrs),
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }